<template>
    <XyzTransition appear xyz="fade">
        <nav class="flex ml-6 mb-5 pt-10" aria-label="Breadcrumb">
            <ol class="flex flex-wrap items-center space-x-1 md:space-x-2">
                <li>
                    <div class="flex items-center">
                        <Link
                            :href="'/' + routeName"
                            class="text-gray-700 hover:text-gray-900 ml-1 md:ml-2 text-2xl font-medium hover:underline"
                        >
                            {{ name }}
                        </Link>
                    </div>
                </li>
                <li>
                    <div class="flex items-center">
                        <Icon size="20">
                            <AngleRight class="text-gray-700" />
                        </Icon>
                        <span
                            class="text-gray-400 ml-1 md:ml-2 text-2xl font-medium"
                            aria-current="page"
                        >
                            {{ page }}
                        </span>
                    </div>
                </li>
            </ol>
        </nav>
    </XyzTransition>
</template>

<script>
import { Icon } from "@vicons/utils";
import { AngleRight } from "@vicons/fa";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    name: "Breadcrumb",
    components: {
        Icon,
        AngleRight,
        Link,
    },
    props: {
        name: String,
        routeName: String,
        page: String,
    },
};
</script>
